import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";

// CSS
import "./index.scss";

function Popmenu({ items, searchable = false, searchPlaceholder = "Search..." }) {
	const [searchTerm, setSearchTerm] = useState("");

	const filteredItems = useMemo(() => {
		if (!searchable || !searchTerm.trim()) return items;
		return items.filter((item) => item.text?.toLowerCase().includes(searchTerm.toLowerCase()));
	}, [items, searchTerm, searchable]);

	const renderItems = () =>
		filteredItems.map((el, i) => {
			switch (el.type) {
				case "export":
					if (!el.disabledBtn) {
						return (
							<CSVLink
								className={`pop-export pop-button ${el.active ?? false ? "active" : ""} ${
									el.disabledBtn ?? false ? "disabled" : ""
								}`}
								key={i}
								asyncOnClick={true}
								onClick={(event, done) => {
									done();
									el.callback(event);
								}}
								headers={el.csvHeaders}
								data={el.csvData}
								filename={el.csvFilename}
								target="_blank"
							>
								{el.text}
							</CSVLink>
						);
					} // Disabled CSVLink should be rendered as button type
				// falls through
				case "button":
					return (
						<button
							className={`pop-button ${el.active ?? false ? "active" : ""} ${
								el.disabledBtn ?? false ? "disabled" : ""
							}`}
							onClick={el.callback}
							key={i}
							disabled={el.disabledBtn}
						>
							{el.text}
						</button>
					);
				case "link":
					return (
						<Link
							className={`pop-link ${el.active ?? false ? "active" : ""}`}
							to={{ pathname: el.to }}
							key={i}
						>
							{el.text}
						</Link>
					);
				default:
					console.log("Invalid Item Type");
			}
		});

	// Searchable menus (like silo selector) use wrapper div with overflow handling
	if (searchable) {
		return (
			<div className="pop-menu scrollable">
				<div className="pop-menu-search">
					<input
						type="text"
						placeholder={searchPlaceholder}
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						onClick={(e) => e.stopPropagation()}
						autoFocus
					/>
				</div>
				<div className="pop-menu-items">
					{filteredItems.length === 0 && searchTerm && (
						<span className="pop-menu-empty">No results found</span>
					)}
					{renderItems()}
				</div>
			</div>
		);
	}

	// Regular menus use original flat structure
	return (
		<div className="pop-menu">
			{renderItems()}
		</div>
	);
}

Popmenu.propTypes = {
	items: PropTypes.array.isRequired,
	searchable: PropTypes.bool,
	searchPlaceholder: PropTypes.string,
};

export default Popmenu;
